import { getParams } from './helpers/params.js';

function setCTAParamsFromCurrentURL (selector = '[href^="https://app.sermo.com/"]', ) {
	const ctas = document.querySelectorAll(selector);
	if (!ctas.length) return;
	let params = getParams(),
		key,
		value;
	for (let cta of ctas) {
		const url_string = cta.href;
		console.log(url_string);
		const url = new URL(url_string);
		for ([key, value] of Object.entries(params)) {
			if (!key.startsWith('utm')) continue;
			url.searchParams.set(key, value);
			cta.href = url.toString();
		}
	}
}

setCTAParamsFromCurrentURL();
